import { addToRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupSidebarLoadFulfilledAction } from '../../domains/groupSidebarLoad/actions.types';

import { GroupExtendedDescriptions } from './types';

export type GroupExtendedDescriptionAction = GroupSidebarLoadFulfilledAction;

const initialState: GroupExtendedDescriptions = {};

const stateWithFulfilledGroupExtendedDescription = (
  state: GroupExtendedDescriptions,
  { id, entities }: GroupSidebarLoadFulfilledAction['payload']
): GroupExtendedDescriptions => addToRecord(state, id, entities.groupExtendedDescriptions[id]);

const reducer: Reducer<GroupExtendedDescriptions, GroupExtendedDescriptionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return stateWithFulfilledGroupExtendedDescription(state, action.payload);
    default:
      return state;
  }
};
export default reducer;
